import { graphql } from 'react-relay';

export const privacyPolicyChangeNoticeQuery = graphql`
    query privacyPolicyChangeNoticeQuery($userId: String!, $hasSessionCountryCode: Boolean!) {
        viewer {
            user(userId: $userId) {
                createdDate
            }
            regionalInfo @skip(if: $hasSessionCountryCode) {
                countryCode
            }
        }
    }
`;
